import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SessionState {
  uid: string | null;
  email: string | null;
  displayName: string | null;
  activeProjectId: string | null;
  activeSprintId: string | null;
}

const STORAGE_KEY = 'sprint-dashboard.activeContext';

const loadContext = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { activeProjectId: null, activeSprintId: null };
    return JSON.parse(raw) as { activeProjectId: string | null; activeSprintId: string | null };
  } catch {
    return { activeProjectId: null, activeSprintId: null };
  }
};

const persistContext = (s: SessionState) => {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      activeProjectId: s.activeProjectId,
      activeSprintId: s.activeSprintId,
    }),
  );
};

const initialState: SessionState = {
  uid: null,
  email: null,
  displayName: null,
  ...loadContext(),
};

const slice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setUser(
      state,
      action: PayloadAction<{ uid: string; email: string | null; displayName: string | null } | null>,
    ) {
      if (action.payload) {
        state.uid = action.payload.uid;
        state.email = action.payload.email;
        state.displayName = action.payload.displayName;
      } else {
        state.uid = null;
        state.email = null;
        state.displayName = null;
        state.activeProjectId = null;
        state.activeSprintId = null;
        persistContext(state);
      }
    },
    setActiveProject(state, action: PayloadAction<string | null>) {
      state.activeProjectId = action.payload;
      state.activeSprintId = null;
      persistContext(state);
    },
    setActiveSprint(state, action: PayloadAction<string | null>) {
      state.activeSprintId = action.payload;
      persistContext(state);
    },
  },
});

export const { setUser, setActiveProject, setActiveSprint } = slice.actions;
export default slice.reducer;
